import * as React from 'react';
import * as styles from './HomeownerBlock.css';
import * as PropTypes from 'prop-types';
import { IOffer } from '../../types/offer';
import { GreenTick } from '../Icons';
import { IOfferHelper } from '../../presenter';
import { PhoneButton } from '../../offer-card/components/AgentBrand/phoneButton/PhoneButton';
import { IButtonsTracking } from '../../offer-card/components/buttons/tracking';
import { ContactStatus } from '../../common/components/ContactStatus';

export interface IHomeownerBlockContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
  api: {
    tracking: IButtonsTracking;
  };
  onlineShowEnabled: boolean;
}

export const PROOF_TEXTS: {[index: string]: string} = {
  passport: 'Предоставил паспорт',
  rosreestr: 'Проверено Росреестром',
  selfEmployed: 'Сдаёт как самозанятый',
};

export class HomeownerBlock extends React.PureComponent {
  public context: IHomeownerBlockContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    api: PropTypes.object,
    onlineShowEnabled: PropTypes.bool,
  };

  public render () {
    const { offer, offerHelper } = this.context;
    const { homeownerProofs, kp } = offer;
    const { onlineShowEnabled } = this.context;

    const isPhoneHidden = !!kp && !kp.displayBuilderPhone;
    const phones = offerHelper.presenters.getPhones();
    const canShowOnline = onlineShowEnabled && Boolean(offer.user && offer.user.canShowOnline);

    return (
      <div onClick={this.handleClickWithStopPropagation}>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>Собственник</div>

          <div className={styles['line']} />

          {Array.isArray(homeownerProofs) && homeownerProofs.length > 0 && (
            <ul className={styles['proofs']}>
              {homeownerProofs.map((proof) => (
                <li className={styles['proof']} key={proof}>
                  <GreenTick />
                  {PROOF_TEXTS[proof]}
                </li>
              ))}
            </ul>
          )}
          {canShowOnline && (
            <ContactStatus
              labelText="Онлайн-показ"
              tooltipTitle="Выбирайте не выходя из дома"
              tooltipText="Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы"
            />)}
          {!isPhoneHidden && phones &&
            <PhoneButton
              offer={offer}
              onPhoneOpened={this.handlePhoneOpen}
              phones={phones}
              dynamicCalltrackingPlaceType="sidePanel"
              hasContactLabel={canShowOnline}
            />
          }
        </div>
      </div>
    );
  }

  private handlePhoneOpen = () => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackPhoneOpened) {
      tracking.trackPhoneOpened();
    }
  }

  private handleClickWithStopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }
}
